import React from "react";

export const DefaultToast = ({ message }) => {
	const splitMessage = message["message"].split("<br>");
	return (
		<div>
			{splitMessage.map((line, index) => (
				<span key={index}>
					{line}
					{index < splitMessage.length - 1 && <br />}
				</span>
			))}
		</div>
	);
};
